import React from "react";
import DataGridComponent from "Utils/Constants/DataGridComponent";
import { whitepapersList } from "Utils/Helpers/TableColumns";

export default function TableWhitepapersData({ data }) {
  return <DataGridComponent data={data} columns={whitepapersList} rowHeight={75} />;
}
